export default __webpack_public_path__ + "static/media/info-card-1.9dbf7537.jpg";